import Reveal from '../motion/Reveal';

export default function Footer() {
  return (
    <footer className="relative px-6 md:px-14 pt-16 pb-12 bg-bg-deep text-center overflow-hidden border-t border-border">
      <div aria-hidden="true" className="absolute inset-0 bg-gridiron pointer-events-none" />
      <Reveal className="relative">
        <div className="font-display font-black uppercase leading-[0.85] text-ink-primary" style={{ fontSize: 'clamp(40px, 8vw, 96px)' }}>
          BRUINS<span className="text-accent-gold">09</span>
        </div>
        <div className="mt-4 font-body italic text-ink-secondary text-base md:text-lg">
          Where Championships Go to Die and Kevin Goes to Cry
        </div>
        <div className="mt-3 font-mono text-[10px] text-ink-muted tracking-[0.25em] uppercase">
          Class of '09 · Est. 2013 · Thirteen seasons deep
        </div>
      </Reveal>
    </footer>
  );
}
